import React from 'react';

import {
  IconCar,
  IconChartHistogram,
  IconReport,
  IconSettings,
  IconSpeakerphone,
  IconUser,
} from '@tabler/icons-react';
import {
  POPOVER_MENU_DEFS,
  SidebarPopoverLink,
} from 'components/SideNavbar/SidebarPopover/SidebarPopover.defs.tsx';
import { PopoeverMenuKeys } from 'components/SideNavbar';

export const ABBR_POPOVER_MENU_DEFS: Record<
  Exclude<PopoeverMenuKeys | 'reports', 'more'>,
  {
    key: PopoeverMenuKeys | 'reports';
    title: string;
    icon: React.ReactElement;
    pathname?: string[];
    children?: SidebarPopoverLink[];
  }
> = {
  analytics: {
    key: 'analytics',
    title: 'Analytics',
    pathname: ['analytics'],
    icon: <IconChartHistogram color='var(--icon-strong)' />,
    children: [
      ...POPOVER_MENU_DEFS.analytics.Risk,
      { title: 'divider', icon: <></>, location: '' },
      ...POPOVER_MENU_DEFS.analytics.Market,
    ],
  },
  inventory: {
    key: 'inventory',
    title: 'Inventory',
    pathname: ['inventory', 'vvo'],
    icon: <IconCar color='var(--icon-strong)' />,
    children: POPOVER_MENU_DEFS.inventory.Inventory,
  },
  campaigns: {
    key: 'campaigns',
    title: 'Campaigns',
    pathname: ['campaigns'],
    icon: <IconSpeakerphone color='var(--icon-strong)' />,
    children: POPOVER_MENU_DEFS.campaigns.Campaigns,
  },
  leadRevival: {
    key: 'leadRevival',
    title: 'Shoppers',
    pathname: ['leadRevival'],
    icon: <IconUser color='var(--icon-strong)' />,
  },
  dealerManagement: {
    key: 'dealerManagement',
    title: 'Dealer management',
    icon: <IconSettings color='var(--icon-strong)' />,
    pathname: ['settings', 'admin'],
    children: [
      ...POPOVER_MENU_DEFS.dealerManagement.Settings,
      { title: 'divider', icon: <></>, location: '' },
      ...POPOVER_MENU_DEFS.dealerManagement.Admin,
    ],
  },
  reports: {
    key: 'reports',
    title: 'Reports',
    icon: <IconReport color='var(--icon-strong)' />,
  },
};
